module.exports = __webpack_public_path__ + "img/t2-c6.6909f971.png";